module.exports = __webpack_public_path__ + "img/aboutus.224e4e66.jpg";